<template>
  <div class="animated fadeIn">    
    <vue-headful title="LMLINE - Clients" description="LMLINE - Clients" />
  <CCard>
    <CCardHeader>
      <span class="h3 mb-1">
            <font-awesome-icon icon="users" />
            {{ $t('clients.title') }}
          </span>
    </CCardHeader>
    <CCardBody>
      <CRow>
        <CCol lg="6" class="my-1">
          <b-form-group
            label-cols-sm="4"
            label-cols-lg="3"
            content-cols-sm
            content-cols-lg="7"
            label="Recherche" 
            >
            <b-form-input/>
          </b-form-group>          
        </CCol>
        <CCol>
          <CRow>
            <CCol>
              <b-form-group
                label-cols-sm="4"
                label-cols-lg="3"
                content-cols-sm
                content-cols-lg="7"
                label="Par page:" 
              >
                <b-form-select
                  id="per-page-select"
                  :options="pageOptions"
                  v-model="perPage"  
                />
              </b-form-group>  
            </CCol>
            <CCol>
              <b-pagination 
                class="float-right"
                :total-rows="totalItems"
                v-model="currentPage"
                :per-page="perPage"/>
            </CCol>
          </CRow>
        </CCol>
      </CRow>
      <b-table
        ref="tableCompanies"
        show-empty
        :busy.sync="isLoading"
        :items="items"
        :fields="fields"
        :current-page="currentPage" 
        :per-page="0"/>
    </CCardBody> 
  </CCard>
  </div>
</template>

<script>
import ApiService  from '../../services/api.service'

export default {
  name: 'CompaniesList',
  // components: { VueBootstrap4Table },
  data(){
    return {
      items: [],
      fields: [
        {
          key: 'id',
          label: 'ID'
        },
        {
          key: 'name',
          label: 'Name'
        },
        {
          key: 'code',
          label: 'Code'
        },
      ],
      isLoading: false,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15, 25, { value: 100, text: "Show a lot" }],
      totalItems: 0,
      from: 0,
      to: 0
    }
  },
  methods: {
    async fetchData() {
      this.isLoading = true
      let request = {
        method: 'get',
        url: '/companies/',
        params: {
          q:{
            sort: [],
            filters: [],
            global_search: "",
          },          
          per_page: this.perPage,
          page: this.currentPage,
        }
      }
      this.items = await ApiService.customRequest(request)
        .then(res => {
          this.isLoading = false
          console.log('Res',res)
          this.totalItems = res.data.pagination['count'] || 0
          this.from = res.data.pagination['from'] || 0
          this.to = res.data.pagination['to'] || 0
          return res.data.companies
        })
        .then(items => items)
    }
  },
  watch: {
    currentPage: {
      handler: function(value) {
        this.fetchData().catch(error => {
          console.error(error)
        })
      }
    },
    perPage: {
      handler: function(value) {
        this.fetchData().catch(error => {
          console.error(error)
        })
      }
    },
  },
  filters: {
  },
  computed: {
    
  },
  mounted(){ 
    this.fetchData().catch(error => {
      console.error(error)
    })
  },

}
</script>
<style>

</style>